import { Button, Card, CardActions, CardContent, CardHeader, Divider, Modal } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));
function CiktiSmsGonder({ open, onClose, forceOpen, FisNo, tasks, className, ciktiTip, ciktiTipTxt }) {
  const classes = useStyles();
  const [LoadingControlCiktiSms, setLoadingControlCiktiSms] = useState(false);
  const [uyariAciklamaCiktiSms, setUyariAciklamaCiktiSms] = useState('');
  const [uyariCiktiSms, setUyariCiktiSms] = useState(false);
  const [uyariTipCiktiSms, setUyariTipCiktiSms] = useState();
    let history = useHistory();
  let AramaDataCiktiSms = [];

  const taskList = Array.isArray(tasks?.tasks) ? tasks.tasks : [];
  AramaDataCiktiSms = taskList?.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) || [];






  if (!open) {
    return null;
  }
  const handleFgsAramaYapEvet = (event, tip, FisNo, Musteri) => {
    setLoadingControlCiktiSms(true);
    let job = AramaDataCiktiSms[0];
    axios.get(`SetArtemisCiktiSms/${job.BasvuruNo}/${job.BIRIM_KODU}/${job.TEKNISYEN_KODU}/${tip || 0}/${ciktiTip || 0}`)
      .then(response => {
        setLoadingControlCiktiSms(false);
        setUyariTipCiktiSms("success");
        setUyariAciklamaCiktiSms('İşleminiz başarı ile gerçekleştirildi.');
        setUyariCiktiSms(true);
        forceOpen();
        if (job.AEEE_SORU === -1 && job.URUN_IADE === 1) {
          confirmAlert({
            message: "AEEE işlemleri için yönlendiriliyorsunuz.",
            buttons: [
              {
                label: 'Tamam',
                onClick: () => { history.push(`/WorkOrder/${FisNo}/Aeee`); }
              }
            ]
          });
        }
      }).catch(error => {
        setLoadingControlCiktiSms(false);
        setUyariTipCiktiSms("error");
        setUyariAciklamaCiktiSms("Bir Hata Oluştu!.. " + (error.response?.data?.error || ''));
        setUyariCiktiSms(true);
        forceOpen();
      });
  }
  const handleFgsAramaYap = (event, Telefon, tip, FisNo, Musteri) => {
    var UyariCiktiSms = "Müşterimiz " + Musteri + " ın " + Telefon + " numaralı telefonuna " + ciktiTipTxt + " için sms gönderilecektir. Onaylıyor musunuz?";
    onClose();
    confirmAlert({
      message: UyariCiktiSms,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleFgsAramaYapEvet(event, tip, FisNo, Musteri)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }

  const uyariKapatCiktiSms = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariCiktiSms(false);
  };
  const OnizlemeCiktiSms = (event, WorkId) => {
    var LinkCiktiSms = process.env.REACT_APP_CIKTI_URL;
    if (ciktiTip === 1) {
      LinkCiktiSms = LinkCiktiSms + 'FisCiktisi.html?GUID=' + WorkId;
    }
    if (ciktiTip === 3) {
      LinkCiktiSms = LinkCiktiSms + 'RevizyonKarti.html?GUID=' + WorkId;
    }

    event.persist();
    window.open(LinkCiktiSms);
    event.persist();
  }


  const getTitleCiktiSms = (event) => {
    return event[0]?.FisNo + " " + event[0]?.Musteri + " " + event[0]?.BasvuruNedeni + " ilgili fiş için " + ciktiTipTxt + " sms'i gönderilecektir.";
  }


  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card
        className={clsx(classes.root, className)}
      >
        <form>
          <CardHeader title={getTitleCiktiSms(AramaDataCiktiSms)} />
          <Divider />
          <CardContent>
            {
              LoadingControlCiktiSms ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                : <div></div>
            }
            <div>
              <div className={classes.wrapper}>
                {
                  AramaDataCiktiSms?.[0]?.Telefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaDataCiktiSms[0]?.Telefon, 1, AramaDataCiktiSms[0]?.FisNo, AramaDataCiktiSms[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      {AramaDataCiktiSms[0]?.Telefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaDataCiktiSms?.[0]?.Telefon2 !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaDataCiktiSms[0]?.Telefon2, 2, AramaDataCiktiSms[0]?.FisNo, AramaDataCiktiSms[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      {AramaDataCiktiSms[0]?.Telefon2}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaDataCiktiSms?.[0]?.Telefon3 !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaDataCiktiSms[0]?.Telefon3, 3, AramaDataCiktiSms[0]?.FisNo, AramaDataCiktiSms[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      {AramaDataCiktiSms[0]?.Telefon3}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaDataCiktiSms?.[0]?.ArayanTelefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaDataCiktiSms[0]?.ArayanTelefon, 4, AramaDataCiktiSms[0]?.FisNo, AramaDataCiktiSms[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      ArayanTelefon : {AramaDataCiktiSms[0]?.ArayanTelefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaDataCiktiSms?.[0]?.IrtibatTelefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaDataCiktiSms[0]?.IrtibatTelefon, 5, AramaDataCiktiSms[0]?.FisNo, AramaDataCiktiSms[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      IrtibatTelefon : {AramaDataCiktiSms[0]?.IrtibatTelefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaDataCiktiSms?.[0]?.ALICI_GSM !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButton}
                      onClick={(event) => handleFgsAramaYap(event, AramaDataCiktiSms[0]?.ALICI_GSM, 6, AramaDataCiktiSms[0]?.FisNo, AramaDataCiktiSms[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      DoğrulamaTelefon : {AramaDataCiktiSms[0]?.ALICI_GSM}
                    </Button>
                    : <div></div>
                }
              </div>
            </div>
            <div>
              {
                uyariCiktiSms ?
                  <Alert onClose={uyariKapatCiktiSms} open={uyariCiktiSms} message={uyariAciklamaCiktiSms || ''} variant={uyariTipCiktiSms} />
                  : <div></div>
              }
            </div>
          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<VisibilityIcon>Onizleme</VisibilityIcon>}
              onClick={(event) => OnizlemeCiktiSms(event, AramaDataCiktiSms?.[0]?.WorkId)}
            >
              Önizleme
            </Button>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Onizleme</CloseIcon>}
              onClick={onClose}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

CiktiSmsGonder.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

CiktiSmsGonder.defaultProps = {
  open: false,
  onClose: () => { }
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(CiktiSmsGonder);
